<template>
  <div class="change-timezone">
      <h3>Change Timezone</h3>
      <div class="current-timezone common-block">
          <label>Current Timezone</label>
          <span v-if="currentTimezone != null && currentTimezone != ''">{{currentTimezone}}</span>
      </div>
      <div class="new-timezone common-block">
          <label>Select New Timezone</label>
          <ob-select2 style="width:30%" :class="{ 'ob-vuelidate_input-error': $v.newTimezone.$error }" @input="$v.newTimezone.$touch()" v-if="timezoneOptions.data.length > 0" :options="timezoneOptions" v-model="newTimezone"></ob-select2>
          <div v-else class="emptyDiv"><i>Fetching the all timezones...</i></div>
          <span class="ob-vuelidate_error-msg" v-if="$v.newTimezone.$dirty && !$v.newTimezone.required">Please select the timezone</span>
      </div>
      <div class="actions-btn common-block">
          <ob-button type="primary" @click="updateTimezone()">Apply Changes</ob-button>
          <!--<ob-button type="secondary">Close</ob-button>-->
      </div>
  </div>
</template>



<script>
    import { required, minLength, maxLength, requiredIf, email } from 'vuelidate/lib/validators'
    export default {

        data() {
            return {
                newTimezone:'',
                currentTimezone:'',
                timezoneOptions:{
                    placeholder: {
                        id: '-1', // the value of the option
                        text: 'Please select'
                    },
                    data:[]
                }
            }
        },
     validations(){
            return {
                newTimezone:{
                    required
                }
            }
        },
    created(){
        this.getAllTimezones()
        },
    methods: {
        getAllTimezones(){
            ajax.get("GetUserCurrentTimezone",{},(res) => {
                if(res.data.State == true){
                    if(res.data.CurrentTimezone == '(India Standard Time)')
                        this.currentTimezone = 'India Standard Time'
                    else
                        this.currentTimezone = res.data.CurrentTimezone
                }
                else
                    this.ESSEnableDisable(res)
            })
            ajax.get("GetAllTimezones",{},(res) => {
                if(res.data.State == true){
                    let timeZones = res.data.TimezonesList
                    var d = new Date()
                    var n = d.getTimezoneOffset()
                    var split = new Date()
                    var timeZoneFormatted = Intl.DateTimeFormat(split).resolvedOptions().timeZone

                    timeZones.forEach((t) => {
                        if(t.Name != this.currentTimezone)
                            this.timezoneOptions.data.push({'id' : t.Name, 'text' : t.Name})
                    })
                    this.timezoneOptions.data.push({'id' : timeZoneFormatted, 'text' : 'Default Time (System Time)'})
                }
                else
                this.ESSEnableDisable(res)
            })
        },
        updateTimezone(){
            this.$v.newTimezone.$touch();
            if(this.$v.newTimezone.$invalid == false){
                let updateInfo = {
                    "CurrentTimezone": this.currentTimezone,
                    "NewTimezone": this.newTimezone
                }
                 this.$loading({'loadingText': 'Updating Timezone Details...'})
                ajax.post("UpdateUserTimezone",updateInfo,(res) => {
                    if(res.data.State == true){
                        setTimeout(()=>{
                            this.$loading({}).close()
                        },500)
                        //  this.newTimezone = ''
                        this.getAllTimezones()
                        setTimeout(()=>{
                            this.$message({
                                type: 'success',
                                message: 'Timezone updated successfully'
                            })
                         },600)
                    }
                    else{
                        this.ESSEnableDisable(res)
                         this.$message({
                          type: "error",
                          message: res.data.Message
                        });

                    }
                })
            }
            }

    }

    }
</script>
<style lang="scss" scoped>
  .change-timezone{
      padding:10px;
      height:100%;
      overflow:auto;
      .select2-results__option[aria-selected=true] {
        display: none;
      }
      h3{
        color: #143361;
        font-weight: 600;
        margin: 0;
        padding: 20px 0;
     }
     .common-block{
         display:inline-block;
         width:100%;
         padding:10px 0;
     }
     label{
         font-size: 13px;
         color: #676a6c;
         font-weight: 400;
     }
     .current-timezone{
         span{
            display: inline-block;
            width: 100%;
            font-size: 14px;
            color: #143361;
        }
     }

  }
</style>
<style lang="scss">
.change-timezone .select2-search, .change-timezone .select2-search--dropdown{
        display:none !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/ESSSettings/EmpChangeTimezone.vue